export default __webpack_public_path__ + "static/media/tick.0c06bbf5.svg";